import React, { useState } from 'react';

const defaultValue = {
  contasReceber: [],
  contaReceberAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  page: 0,
  size: 15,
  sort: 'dataVencimento,DESC',
};

export const ResgatarContaReceberContratoContext = React.createContext({});

export const ResgatarContaReceberContratoProvider = (props) => {
  return (
    <ResgatarContaReceberContratoContext.Provider
      value={{
        contasReceber: useState(defaultValue.contasReceber),
        contaReceberAtual: useState(defaultValue.contaReceberAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        dataVencimentoInicio: useState(defaultValue.dataVencimentoInicio),
        dataVencimentoFim: useState(defaultValue.dataVencimentoFim),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
      }}
    >
      {props.children}
    </ResgatarContaReceberContratoContext.Provider>
  );
};

export const ResgatarContaReceberContratoConsumer = ResgatarContaReceberContratoContext.Consumer;
